"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBlastSendDto = exports.NotificationBlastQueryMetadataDto = exports.NotificationBlastQueryDto = exports.CustomersQueryDto = void 0;
/*
 * Customer-specific query parameters.
 */
class CustomersQueryDto {
}
exports.CustomersQueryDto = CustomersQueryDto;
/*
 * Builds the query used to segment users for a blast notification.
 */
class NotificationBlastQueryDto {
}
exports.NotificationBlastQueryDto = NotificationBlastQueryDto;
/*
 * Metadata about the results of a NotificationBlastQueryDto.
 */
class NotificationBlastQueryMetadataDto {
}
exports.NotificationBlastQueryMetadataDto = NotificationBlastQueryMetadataDto;
/*
 * Combines a Notification and a Query, used to send the blast.
 */
class NotificationBlastSendDto {
}
exports.NotificationBlastSendDto = NotificationBlastSendDto;
//# sourceMappingURL=notification.blast.query.dto.js.map